import classNames from 'classnames';
import { ArrowProps, CarouselArrowType } from './types';
import { IconArrowSquareLeft, IconArrowSquareRight } from '../icons';
function Arrow({
  disabled,
  direction = 'right',
  onClick,
  type
}: ArrowProps) {
  return <span onClick={onClick} className={classNames('absolute top-1/2 z-10 hidden -translate-y-1/2 cursor-pointer items-center justify-center rounded-md bg-surface-scrim-white lg:flex', (type === CarouselArrowType.ProductList || type === CarouselArrowType.MediumCarousel || type === CarouselArrowType.InteractifyGallery) && (direction === 'left' ? 'left-1.5' : 'right-1.5'), type === CarouselArrowType.MediumCarousel && 'lg:h-[40px] lg:w-[40px]', type === CarouselArrowType.PDP && (direction === 'left' ? 'left-3' : 'right-3'), type === 'pink-box' && (direction === 'left' ? 'left-2.5' : 'right-2.5'), type === CarouselArrowType.IranianWomen && (direction === 'left' ? '-left-6' : '-right-6'), {
    '!flex': type === CarouselArrowType.InteractifyGallery,
    'h-6 w-6 text-text-black': type === CarouselArrowType.PDP,
    'h-9 w-9 !rounded-full bg-surface-solid-100': type === CarouselArrowType.IranianWomen,
    'h-8 w-8 border border-border-gray-medium': type === CarouselArrowType.ProductList || type === CarouselArrowType.PinkBox || type === CarouselArrowType.MediumCarousel || type === CarouselArrowType.InteractifyGallery,
    '!hidden': disabled
  })} data-sentry-component="Arrow" data-sentry-source-file="arrow.tsx">
            {direction === 'left' && <IconArrowSquareLeft className={classNames({
      'h-4 w-4': type === CarouselArrowType.PDP,
      'h-7 w-7': type === CarouselArrowType.MediumCarousel,
      'h-6 w-6': type !== CarouselArrowType.PDP && type !== CarouselArrowType.MediumCarousel
    })} />}
            {direction === 'right' && <IconArrowSquareRight className={classNames({
      'h-4 w-4': type === CarouselArrowType.PDP,
      'h-7 w-7': type === CarouselArrowType.MediumCarousel,
      'h-6 w-6': type !== CarouselArrowType.PDP && type !== CarouselArrowType.MediumCarousel
    })} />}
        </span>;
}
export default Arrow;